import React from 'react';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import IconButton from '@material-ui/core/IconButton';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { withStyles } from '@material-ui/core/styles';
import { Subtitle2, Body2 } from 'components/Typography';
import styles from './styles';

function ItemPicker(props) {
    return (
        <ListItem button={!props.disabled} onClick={props.disabled ? null : props.onSelectionChanged} className={props.classes.listItemRoot}>
            {props.icon &&
                <ListItemIcon>
                    <div className={props.disabled ? '' : props.activeClass}>
                        {props.icon}
                    </div>
                </ListItemIcon>
            }
            {props.selected &&
                <ListItemText>
                    <Subtitle2>{props.pickerName}</Subtitle2>
                    <Body2>{props.selectedText}</Body2>
                </ListItemText>
            }
            {!props.selected &&
                <ListItemText>
                    <Subtitle2>{props.pickerName}</Subtitle2>
                    <Body2>Select</Body2>
                </ListItemText>

            }
            {!props.disabled &&
                <ListItemSecondaryAction>
                    <IconButton aria-label="Select" onClick={props.onSelectionChanged} className={props.classes.chevron}>
                        <ChevronRightIcon />
                    </IconButton>
                </ListItemSecondaryAction>
            }

        </ListItem>
    );
}

export default withStyles(styles)(ItemPicker);